<template>
  <div>
    <BaseCompletePage
      :content="getCoverLandlords"
      :sdnData="isLandlords ? SDN_DATA_LL : SDN_DATA"
      :sdnDataAdvised="isLandlords ? SDN_DATA_ADVISED_LL : SDN_DATA_ADVISED"
      :cardTitle="
        $vuetify.breakpoint.lgAndUp
          ? 'Your Landlord’s Insurance quote'
          : 'Your quote'
      "
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { QUESTIONS_MODULE } from "@/store/types/module-types";

// SDN dependencies
import {
  SDN_DATA,
  SDN_DATA_LL,
  SDN_DATA_ADVISED,
  SDN_DATA_ADVISED_LL,
} from "@/constants/sdn.constants";
import BaseCompletePage from "@/views/BaseCompletePage.vue";

export default {
  name: "CompletePage",
  components: {
    BaseCompletePage,
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, ["isLandlords", "getCoverLandlords"]),
  },
  data() {
    return {
      SDN_DATA,
      SDN_DATA_LL,
      SDN_DATA_ADVISED,
      SDN_DATA_ADVISED_LL,
    };
  },
};
</script>
